import * as definition from '@/lib/highlightMappings'
import bossSCommon from '@/lib/bossSCommon'
import util from '@/lib/util.js'
const USER_URL = process.env.USER_ENDPOINT
const BOSS_C_URL = process.env.BOSS_C_ENDPOINT

/**
 * プレビュー表示に関わる定数・処理をまとめたmixin
 */
export default {
  mixins: [bossSCommon],
  computed: {
    bossCEndPoint: () => BOSS_C_URL,
    userImageUrlForPc: () => `${USER_URL}/th/pc/img`,
    userOfferImageUrlForPc: () => `${USER_URL}/th/pc/img/offer`,
    userOfferImageUrlForSp: () => `${USER_URL}/th/sp/img/offer`,
    userCommonImageUrlForPc: () => `${USER_URL}/th/pc/img/common`,
    userCommonImageUrlForSp: () => `${USER_URL}/th/sp/img/common`,
    userHelpURL: () => `${USER_URL}/s/help`,
    googleMapURL: () => 'https://www.google.co.jp/maps?q=',
    tooltip: () => definition.tooltips,
    average: () => definition.averages,
    targetIdMap: () => definition.targetIdMap,
    textCountHeight: () => 30, // 文字数カウント1つの高さ
    tag () {
      return this.highlightMode ? 'span' : 'a'
    },
    isPublished () {
      return this.$route.name === 'jobPublishedPreview'
    },
    strengthTitle () {
      return {
        language: '語学を活かせる',
        education: '教育制度について',
        license: '資格取得支援制度について',
        femaleManager: '女性管理職について'
      }
    },
    offerPointTitle () {
      if (this.isCompanyStaffAccess) return '募集要項'
      return '募集要項（給与コード、対象学歴、年齢、年収は企業側には表示されません）'
    },
    questionTitle () {
      if (!this.jobCategorySettings?.questionItems) {
        return '独自質問項目'
      }
      const isOffer = this.jobCategorySettings.questionItems.isOfferOriginalQuestion
      if (isOffer) {
        return '独自質問項目(この求人は、求人に設定した独自質問項目が有効です)'
      } else {
        return '独自質問項目(この求人は、企業に設定した独自質問項目が有効です)'
      }
    },
    // 表示/非表示 判定セット
    isShow () {
      return {
        attentions: Object.keys(this.attentionsNotEmpty).length,
        improved: this.description?.isLightPlan && this.description?.improved,
        strengths: Object.keys(this.strengthsNotEmpty).length,
        post: this.requirements?.post || this.requirements?.ageRatio || this.requirements?.sexRatio,
        employee: this.companyInfo?.employeeNumber || this.companyInfo?.averageAge || this.companyInfo?.midCareerPercentage,
        representative: this.companyInfo?.representative || this.companyInfo?.representativeProfile,
        interview: (index) => {
          return this.selection && (this.selection[`zipCode${index}`] || this.selection[`address${index}`] || this.selection[`tel${index}`])
        },
        links: this.selection?.companyLinkNm1 || this.selection?.companyLinkNm2 || this.selection?.companyLinkNm3,
        companyImages: this.companyInfo?.companyImage1Caption || this.companyInfo?.companyImage2Caption || this.companyInfo?.companyImage3Caption
      }
    },
    attentionsNotEmpty () {
      return util.objectFilter(this.description?.attentions, (attentions) => attentions.title)
    },
    strengthsNotEmpty () {
      return util.objectFilter(this.description?.strengths, (strength) => strength)
    },
    certificateCount () { // 国認証でtrueのものがいくつあるかカウント
      let count = 0
      if (this.environment?.isKurumin) count++
      if (this.environment?.isPlatinumKurumin) count++
      if (this.environment?.isNadeshiko) count++
      if (this.environment?.isEruboshi) count++
      return count
    },
    questionItems () {
      return this.jobCategorySettings?.questionItems || {}
    }
  },
  methods: {
    // targetが完全一致するコメントを取得
    getCommentHighlights (target) {
      return this.commentHighlights.filter(commentHighlight => commentHighlight.target === target)
    },
    // targetが前方一致するコメントを取得＋末尾のindexでさらにフィルタ可能
    getAnyCommentHighlights (target, index = null) {
      const commentHighlights = this.commentHighlights.filter(commentHighlight => commentHighlight.target.indexOf(target) > -1)
      if (index !== null) {
        return commentHighlights.filter(commentHighlight => commentHighlight.target.lastIndexOf(index) > -1)
      }
      return commentHighlights
    },
    //  targetが前方一致するコメントを取得（複数条件いずれかに一致）
    getArrayAnyCommentHighlights (targets) {
      return this.commentHighlights.filter(commentHighlight => {
        return targets.some(target => commentHighlight.target.indexOf(target) > -1)
      })
    },
    // 文字数カウントコンポーネント向けのオブジェクト作成
    getTextCount (name, value, targetId, tooltip = null, margin = null) {
      return {
        name: name,
        value: value,
        max: definition.textMaxMap[targetId],
        tooltip: tooltip,
        margin: margin
      }
    },
    // blobから写真を取得するurl生成
    getPhotoUrl (photoData) {
      return photoData && `${this.bossCEndPoint}/api/images/${photoData.id}/classifications/${photoData.kbn}/files/${encodeURIComponent(photoData.fn)}`
    },
    // ヘルプ表示
    openHelpPopUp (path) {
      window.open(`${this.userHelpURL}/${path}`, '_blank', 'width=580,height=650')
    },
    // データで見る働く環境 表示/非表示 判定
    isShowEnvironment (environment) {
      return environment.womanRate != null ||
      environment.officerRate != null ||
      environment.overtime != null ||
      environment.ptoRate != null ||
      environment.maternityRate != null ||
      environment.lengthService != null ||
      environment.isKurumin ||
      environment.isPlatinumKurumin ||
      environment.isNadeshiko ||
      environment.isEruboshi ||
      environment.womanAction
    },
    // 雇用形態 表示/非表示 判定
    isContainEmploymentStatus (employmentStatusId) {
      return this.employmentStatus.includes(employmentStatusId)
    },
    // PRコード 表示/非表示 判定
    isSetPr (prId) {
      return this.prCodes.includes(prId)
    },
    getFreeTopics (offer, isInterview) {
      return offer.requirements.freeTopics
        .map((freeTopic, index) => { return { ...freeTopic, index: index + 1 } })
        .filter(freeTopic => this.isShowFreeTopic(freeTopic) && freeTopic.isInterview === isInterview)
    },
    isShowFreeTopic (freeTopic) {
      return freeTopic.title || freeTopic.body || freeTopic.photo
    }
  }
}
